import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FormattedMessage } from 'react-intl'
import { isMobileSelector } from '../../selectors/device'
import { loggedInSelector } from '../../selectors/users'
import { MenuButtonIcon } from '../../components/menu_button_icon'
import { Popover } from '../../components/popover'
import { PreferencesList } from '../../components/preferences_list'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import styles from './styles'

export const NewReleasesSettings = ({ queryParams, setQueryParams }) => {
  const isLoggedIn = useSelector(loggedInSelector)
  const isMobile = useSelector(isMobileSelector)
  const preferences = useSelector(state => state.preferences.preferences)
  const genrePreferences = useSelector(
    state => state.preferences.genrePreferences
  )
  const preferencesFiltered =
    preferences &&
    preferences.some(
      region =>
        ![1, 5].includes(region.regionId) &&
        region.selected &&
        !region.autoselected
    )
  const genrePreferencesFiltered =
    genrePreferences && Object.values(genrePreferences).some(value => value)
  const isFiltered = preferencesFiltered || genrePreferencesFiltered

  return isLoggedIn ? (
    <Popover
      closeButton={isMobile}
      closeOnClick={false}
      closeOnScroll={false}
      contentClassName={styles.newReleasesSettingsPopover}
      id="newReleasesSettings"
      renderTrigger={({ handleClick, open, ref }) => (
        <button
          className={classNames(
            {
              popoverTrigger: !open,
              popoverTriggerOpen: open,
              [styles.filtered]: isFiltered,
              mobile: isMobile,
            },
            styles.arrowButton
          )}
          onClick={handleClick}
          ref={ref}
        >
          {isMobile ? (
            <FontAwesomeIcon icon="cog" />
          ) : (
            <>
              <FormattedMessage
                defaultMessage="Settings"
                id="djcity.common.newreleases_settings"
              />
              <MenuButtonIcon isOpen={open} />
            </>
          )}
        </button>
      )}
    >
      {({ forceClosePopover }) => (
        <PreferencesList
          forceClosePopover={forceClosePopover}
          isFromPopup={true}
          queryParams={queryParams}
          setQueryParams={setQueryParams}
        />
      )}
    </Popover>
  ) : null
}

NewReleasesSettings.propTypes = {
  queryParams: PropTypes.object,
  setQueryParams: PropTypes.func,
}
